import passengersBooked from './passengersBooked'

export default {
  passengersBooked,
}
